export class WeighingScaleConnection {
    url: string;
    useSimulator: boolean;
    hubConnection: any;
    productProperties: Array<number> = [];
    started: boolean;
    weight: number;
    stable: boolean;
    error: boolean;
  }